import { xl, l, m } from '../Feature/width.js';
import { toQueryString } from './toQueryString.js';

var styledKey = '$q';
var simpleKeyMap = {
  qM: m,
  qL: l,
  qXl: xl
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface

var atRule = '@media ';
var toStyled = function toStyled(props, transform) {
  var style = {};
  var keys = Object.keys(simpleKeyMap);
  for (var i = 0, n = keys.length; i < n; i += 1) {
    var key = keys[i];
    var resultProps = props[key];
    var expression = simpleKeyMap[key];
    if (resultProps) style[atRule + toQueryString(expression)] = transform(resultProps);
  }
  return style;
};
var responsiveStyle = function responsiveStyle(props, style, transform) {
  if (!props.qM && !props.qL && !props.qXl) return undefined;

  // eslint-disable-next-line no-param-reassign
  if (props.qM) style[atRule + toQueryString(m)] = transform(props.qM);
  // eslint-disable-next-line no-param-reassign
  if (props.qL) style[atRule + toQueryString(l)] = transform(props.qL);
  // eslint-disable-next-line no-param-reassign
  if (props.qXl) style[atRule + toQueryString(xl)] = transform(props.qXl);
  return style;
};

export { responsiveStyle, simpleKeyMap, toStyled };
//# sourceMappingURL=toStyled.js.map
